import React, { useState, useEffect } from 'react';
import { useAuth } from '../../AuthContext';
import { LuUser, LuKey, LuLink, LuCheck } from 'react-icons/lu';

export default function ClientProfilePage() {
  const { token, user, setUser } = useAuth();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  // Состояния для установки пароля
  const [showSetPassword, setShowSetPassword] = useState(false);
  const [passwordForm, setPasswordForm] = useState({
    new_password: '',
    confirm_password: ''
  });
  const [passwordLoading, setPasswordLoading] = useState(false);

  // Состояния для смены пароля
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [changePasswordForm, setChangePasswordForm] = useState({
    current_password: '',
    new_password: '',
    confirm_password: ''
  });

  // Состояния для связи с Telegram
  const [showLinkTelegram, setShowLinkTelegram] = useState(false);
  const [telegramForm, setTelegramForm] = useState({
    telegram_id: '',
    telegram_username: ''
  });
  const [telegramLoading, setTelegramLoading] = useState(false);

  useEffect(() => {
    // Проверяем, нужно ли показать форму установки пароля
    if (user && (!user.password_hash || user.password_hash === '')) {
      setShowSetPassword(true);
    }
  }, [user]);

  const handleSetPassword = async (e) => {
    e.preventDefault();
    setPasswordLoading(true);
    setError(null);
    setSuccess(null);

    if (passwordForm.new_password !== passwordForm.confirm_password) {
      setError('Пароли не совпадают');
      setPasswordLoading(false);
      return;
    }

    if (passwordForm.new_password.length < 6) {
      setError('Пароль должен содержать минимум 6 символов');
      setPasswordLoading(false);
      return;
    }

    try {
      const response = await fetch('/api/client/change-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          new_password: passwordForm.new_password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка установки пароля');
      }

      setSuccess('Пароль успешно установлен');
      setShowSetPassword(false);
      setPasswordForm({ new_password: '', confirm_password: '' });
      
      // Обновляем данные пользователя
      const userResponse = await fetch('/api/client/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (userResponse.ok) {
        const userData = await userResponse.json();
        setUser(userData.response || userData);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    setPasswordLoading(true);
    setError(null);
    setSuccess(null);

    if (changePasswordForm.new_password !== changePasswordForm.confirm_password) {
      setError('Пароли не совпадают');
      setPasswordLoading(false);
      return;
    }

    if (changePasswordForm.new_password.length < 6) {
      setError('Пароль должен содержать минимум 6 символов');
      setPasswordLoading(false);
      return;
    }

    try {
      const response = await fetch('/api/client/change-password', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          current_password: changePasswordForm.current_password,
          new_password: changePasswordForm.new_password
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка смены пароля');
      }

      setSuccess('Пароль успешно изменен');
      setShowChangePassword(false);
      setChangePasswordForm({
        current_password: '',
        new_password: '',
        confirm_password: ''
      });
    } catch (err) {
      setError(err.message);
    } finally {
      setPasswordLoading(false);
    }
  };

  const handleLinkTelegram = async (e) => {
    e.preventDefault();
    setTelegramLoading(true);
    setError(null);
    setSuccess(null);

    if (!telegramForm.telegram_id) {
      setError('Telegram ID обязателен');
      setTelegramLoading(false);
      return;
    }

    try {
      const response = await fetch('/api/client/link-telegram', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify({
          telegram_id: telegramForm.telegram_id,
          telegram_username: telegramForm.telegram_username
        })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Ошибка связи с Telegram');
      }

      setSuccess('Аккаунт успешно связан с Telegram');
      setShowLinkTelegram(false);
      setTelegramForm({ telegram_id: '', telegram_username: '' });
      
      // Обновляем данные пользователя
      const userResponse = await fetch('/api/client/me', {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      if (userResponse.ok) {
        const userData = await userResponse.json();
        setUser(userData.response || userData);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setTelegramLoading(false);
    }
  };

  return (
    <main className="client-page-content modern">
      {error && (
        <div className="alert alert-error" style={{ marginBottom: '20px' }}>
          ⚠️ {error}
        </div>
      )}

      {success && (
        <div className="alert alert-success" style={{ marginBottom: '20px' }}>
          <LuCheck /> {success}
        </div>
      )}

      {/* Информация о пользователе */}
      <div className="glass-card info-card accent-card" style={{ marginBottom: '20px' }}>
        <h3 className="client-widget-title"><LuUser /> Информация о пользователе</h3>
        <div className="info-list modern">
          <div className="info-item modern">
            <span className="info-label">📧 Email:</span>
            <span className="info-value">{user?.email || 'Не указан'}</span>
          </div>
          <div className="info-item modern">
            <span className="info-label">💬 Telegram ID:</span>
            <span className="info-value">
              {user?.telegram_id ? (
                <>
                  {user.telegram_id}
                  {user.telegram_username && ` (@${user.telegram_username})`}
                  <span className="status-chip success" style={{ marginLeft: '8px' }}>Связан</span>
                </>
              ) : (
                <span className="text-muted">Не связан</span>
              )}
            </span>
          </div>
          <div className="info-item modern">
            <span className="info-label">🔑 Пароль:</span>
            <span className="info-value">
              {user?.password_hash && user.password_hash !== '' ? (
                <span className="status-chip success">Установлен</span>
              ) : (
                <span className="status-chip danger">Не установлен</span>
              )}
            </span>
          </div>
        </div>
      </div>

      {/* Установка пароля (для пользователей из бота) */}
      {(!user?.password_hash || user.password_hash === '') && (
        <div className="glass-card info-card softer-card" style={{ marginBottom: '20px' }}>
          <h3 className="client-widget-title"><LuKey /> Установить пароль</h3>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '20px', fontSize: '14px' }}>
            У вас нет пароля. Установите пароль для входа на сайте.
          </p>
          {showSetPassword ? (
            <form onSubmit={handleSetPassword}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Новый пароль</label>
                <input
                  type="password"
                  value={passwordForm.new_password}
                  onChange={(e) => setPasswordForm({ ...passwordForm, new_password: e.target.value })}
                  required
                  minLength={6}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Подтвердите пароль</label>
                <input
                  type="password"
                  value={passwordForm.confirm_password}
                  onChange={(e) => setPasswordForm({ ...passwordForm, confirm_password: e.target.value })}
                  required
                  minLength={6}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
                <button type="submit" className="btn btn-primary" disabled={passwordLoading} style={{ flex: '1 1 auto', minWidth: '140px' }}>
                  {passwordLoading ? 'Установка...' : 'Установить пароль'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowSetPassword(false)}
                  style={{ flex: '0 0 auto', minWidth: '100px', width: 'auto' }}
                >
                  Отмена
                </button>
              </div>
            </form>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => setShowSetPassword(true)}
            >
              Установить пароль
            </button>
          )}
        </div>
      )}

      {/* Смена пароля (для пользователей с паролем) */}
      {user?.password_hash && user.password_hash !== '' && (
        <div className="glass-card info-card softer-card" style={{ marginBottom: '20px' }}>
          <h3 className="client-widget-title"><LuKey /> Сменить пароль</h3>
          {showChangePassword ? (
            <form onSubmit={handleChangePassword}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Текущий пароль</label>
                <input
                  type="password"
                  value={changePasswordForm.current_password}
                  onChange={(e) => setChangePasswordForm({ ...changePasswordForm, current_password: e.target.value })}
                  required
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Новый пароль</label>
                <input
                  type="password"
                  value={changePasswordForm.new_password}
                  onChange={(e) => setChangePasswordForm({ ...changePasswordForm, new_password: e.target.value })}
                  required
                  minLength={6}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Подтвердите новый пароль</label>
                <input
                  type="password"
                  value={changePasswordForm.confirm_password}
                  onChange={(e) => setChangePasswordForm({ ...changePasswordForm, confirm_password: e.target.value })}
                  required
                  minLength={6}
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
                <button type="submit" className="btn btn-primary" disabled={passwordLoading} style={{ flex: '1 1 auto', minWidth: '140px' }}>
                  {passwordLoading ? 'Изменение...' : 'Изменить пароль'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowChangePassword(false)}
                  style={{ flex: '0 0 auto', minWidth: '100px', width: 'auto' }}
                >
                  Отмена
                </button>
              </div>
            </form>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => setShowChangePassword(true)}
            >
              Сменить пароль
            </button>
          )}
        </div>
      )}

      {/* Связь с Telegram */}
      {!user?.telegram_id && (
        <div className="glass-card info-card softer-card" style={{ marginBottom: '20px' }}>
          <h3 className="client-widget-title"><LuLink /> Связать с Telegram</h3>
          <p style={{ color: 'var(--text-secondary)', marginBottom: '20px', fontSize: '14px' }}>
            Свяжите ваш аккаунт с Telegram для входа через бота.
          </p>
          {showLinkTelegram ? (
            <form onSubmit={handleLinkTelegram}>
              <div style={{ marginBottom: '16px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Telegram ID *</label>
                <input
                  type="text"
                  value={telegramForm.telegram_id}
                  onChange={(e) => setTelegramForm({ ...telegramForm, telegram_id: e.target.value })}
                  required
                  placeholder="123456789"
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
                <small style={{ display: 'block', marginTop: '6px', fontSize: '12px', color: 'var(--text-secondary)' }}>
                  Ваш Telegram ID можно получить у бота @userinfobot
                </small>
              </div>
              <div style={{ marginBottom: '20px' }}>
                <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', fontSize: '14px' }}>Telegram Username (опционально)</label>
                <input
                  type="text"
                  value={telegramForm.telegram_username}
                  onChange={(e) => setTelegramForm({ ...telegramForm, telegram_username: e.target.value })}
                  placeholder="@username"
                  style={{
                    width: '100%',
                    padding: '12px',
                    borderRadius: '8px',
                    border: '1px solid var(--border-color)',
                    background: 'var(--bg-primary)',
                    color: 'var(--text-primary)',
                    fontSize: '14px'
                  }}
                />
              </div>
              <div style={{ display: 'flex', gap: '12px', alignItems: 'stretch' }}>
                <button type="submit" className="btn btn-primary" disabled={telegramLoading} style={{ flex: '1 1 auto', minWidth: '140px' }}>
                  {telegramLoading ? 'Связывание...' : 'Связать аккаунт'}
                </button>
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowLinkTelegram(false)}
                  style={{ flex: '0 0 auto', minWidth: '100px', width: 'auto' }}
                >
                  Отмена
                </button>
              </div>
            </form>
          ) : (
            <button
              className="btn btn-primary"
              onClick={() => setShowLinkTelegram(true)}
            >
              Связать с Telegram
            </button>
          )}
        </div>
      )}
    </main>
  );
}

